<template>
  <div class="fixed w-full h-full top-0 right-0 bg-g0/90 flex justify-center items-center z-[9999]" @click="close()"
    :class="{
      '!fixed w-screen h-screen': config?.infoType == 'small' || $root.isPopup,
      '!fixed w-screen h-screen': config?.infoType == 'rc'
    }">
    <div class="py-9 px-8 bg-g1 text-white max-w-[600px] w-[80vw] relative" @click.stop="">
      <svg class="absolute top-[12px] right-[12px] cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="15"
        viewBox="0 0 10.561 10.561" @click="close()">
        <g transform="translate(-815.793 -21.793)">
          <line y1="9.147" x2="9.147" transform="translate(816.5 22.5)" fill="none" stroke="#fff" stroke-width="2" />
          <line y1="9.147" x2="9.147" transform="translate(825.647 22.5) rotate(90)" fill="none" stroke="#fff"
            stroke-width="2" />
        </g>
      </svg>


      <div>
        <h2>{{ $e("Lien de partage") }} :</h2>

        <div class="mt-2">

          <div class="flex flex-col mt-4 flex flex-col justify-center" v-if="config.qrCodeOpen != ''">

            <div class="flex items-center relative text-g3 hover:text-white cursor-pointer"
              @click="copy(config.qrCodeOpen)">
              <input type="text" :value="config.qrCodeOpen" readonly
                class="w-full pr-[8px] !cursor-pointer !text-white">
              <button class="absolute right-[5px]">
                <svg class="fill-current w-[20px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 854.5 854.6">
                  <path
                    d="M780.5,726.7h-3.9V201.9c0-68.4-55.6-124-123.9-124H127.9v-3.9C127.9,33.2,161.1,0,201.9,0h578.6c40.8,0,74,33.2,74,74v578.7c-.1,40.8-33.2,74-74,74Z" />
                  <path
                    d="M726.6,780.6V201.9c0-40.8-33.2-74-73.9-74H74C33.2,127.9,0,161.1,0,201.9v578.7c0,40.8,33.2,74,74,74h578.6c40.8,0,74-33.2,74-74ZM333.2,655.5v-134.2h-134.2v-60h134.2v-134.3h60v134.3h134.3v60h-134.3v134.2h-60Z" />
                </svg>
              </button>
            </div>

            <div class="mt-8 flex">
              <button @click="mode = 'qrcode'" :class="{ 'bg-g3': mode != 'qrcode' }" class="btn w-full rounded-none">{{
                $e("QRCode")
              }}
              </button>
              <button @click="mode = 'email'" :class="{ 'bg-g3': mode != 'email' }" class="btn w-full rounded-none">{{
                $e("Email") }}
              </button>
            </div>
            <div class="p-4 border-x-2 border-b-2 border-g2">
              <div v-show="mode == 'qrcode'">
                <div id="qrcode" class=""></div>
              </div>
              <div v-show="mode == 'email'">

                <SendEmailList template="QrCode" :subject="$e('Flux vidéo FlyingHub')" :url="config.qrCodeOpen" @close="close()"/>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { toast } from 'vue3-toastify';
import SendEmailList from "@/partials/SendEmailList.vue";

export default {
  name: "Video_QrCode",
  components: {
    SendEmailList
  },
  setup() {
    return {
      url: ref(''),
      mode: ref('qrcode'),
      site: ref({}),
      mails: ref({}),
    };
  },

  props: {
    config: Object,
  },

  mounted() {
    this.site = this.$root.global.site;

    let size = this.config?.infoType == 'rc'
      ? 150
      : 420;

    new QRCode("qrcode", {
      text: this.config.qrCodeOpen,
      width: size,
      height: size,
      colorDark: "#000000",
      colorLight: "#ffffff",
      correctLevel: QRCode.CorrectLevel.L
    });
  },

  methods: {
    close() {
      this.config.qrCodeOpen = false;
    },

    copy() {
      navigator.clipboard.writeText(this.config.qrCodeOpen);
      toast.success(this.$e('Lien copié'), this.$root.toastConfig);
    },
  },
};
</script>
